import {
  Button,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  makeStyles,
  Box,
  Popover,
  List,
  ListItem,
  ListItemText,
  TextField,
  InputAdornment,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";
import { useContext, useEffect, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import profileNoPic from "../../assets/blank.png";
import { AuthContext } from "../../context/Auth/AuthContext";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import socket from "../../hooks/useSocket";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import ContactConcludeTicket from "../ContactConcludeTicket"; //Concluir Atendimento
import ContactCreateTicketModal from "../ContactCreateTicketModal"; //Criar Ticket **DESABILITADO AINDA**
import ContactFlashMessenger from "../ContactFlashMessenger"; //Mensagens Rapidas
import ContactTransferModal from "../ContactTransferModal"; //Transferencia de atendimento
import MessageInput from "../MessageInput";
import MessagesList from "../MessagesList";
import ForContactsModal from "../Tag/forContactsModal";
import TicketHeader from "../TicketHeader";
import TicketInfo from "../TicketInfo";
import GroupInformationModal from "./GroupInformationModal";

import HowToRegOutlinedIcon from "@material-ui/icons/HowToRegOutlined";
import PauseCircleOutlineOutlinedIcon from "@material-ui/icons/PauseCircleOutlineOutlined";
import AlarmOutlinedIcon from "@material-ui/icons/AlarmOutlined";
import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import PermContactCalendarOutlinedIcon from "@material-ui/icons/PermContactCalendarOutlined";
import GroupIcon from "@material-ui/icons/Group";
import NotificationsIcon from '@material-ui/icons/Notifications';

import classNames from "classnames";
import "./style.scss";
import ScheduleMessageListModal from "../ScheduleMessageListModal";
import GetUrlTicketPath from "../../helpers/GetUrlTicketPath";
import CheckComponentAccess from "../../helpers/CheckComponentAccess";
import ContactModal from "../ContactModal";
import { getAllItems } from "../../helpers/IndexedDb";

import KeyboardArrowDownOutlinedIcon from "@material-ui/icons/KeyboardArrowDownOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    position: "relative",
    overflow: "hidden",
  },
  ticketInfo: {
    maxWidth: "50%",
    flexBasis: "50%",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "80%",
      flexBasis: "80%",
    },
  },
  buttonBox: {
    [theme.breakpoints.down("959")]: {
      display: "inline-flex",
      width: "fit-content",
      float: "right",
      height: "100%",
      paddingTop: "15px",
    },
  },
  buttonDesktop: {
    display: "flex",
    paddingRight: "20px",
    [theme.breakpoints.down("810")]: {
      display: "none",
    },
  },
  buttonMobile: {
    display: "none",
    position: "relative",
    right: "20px",
    top: "0px",
    [theme.breakpoints.down("810")]: {
      display: "flex",
    },
    [theme.breakpoints.down("500")]: {
      right: "0",
    },
    "& button": {
      padding: "0",
      margin: "0",
      top: "-10px",
    },
  },
  buttonsStyle: {
    borderRadius: "0px",
    borderColor: "black",
    color: "black",
    backgroundColor: "white",
    margin: "0px 5px 0px 5px",
  },
  ticketActionButtons: {
    maxWidth: "50%",
    flexBasis: "50%",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      flexBasis: "100%",
      marginBottom: "5px",
    },
  },
  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: "0",
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  filasTexto: {
    display: "flex",
    padding: "27px",
    position: "absolute",
    marginLeft: "28rem",
    "@media(max-width: 1250px)": {
      display: "none !important",
    },
  },
  icon: {
    width: "35px",
    height: "35px",
    margin: "0 2px",
    borderRadius: "100%",
    background: "#e0e0e0",
    color: "#0B708C",
    "&:hover": {
      background: "#bdbdbd",
    },
    "& svg": {
      width: "25px",
      height: "25px",
    },
  },
  header: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("959")]: {
      display: "inline-block",
      position: "relative",
      width: "calc(100% - 65px)",
    },
  },
  flashOnIcon: {
    color: "#0B708C",
    background: "#e0e0e0",
    width: "13px!important",
    height: "13px!important",
    position: "absolute!important",
    bottom: "5px!important",
    right: "3px!important",
  },
  flashOnIconDisabled: {
    color: "#c2c2c2",
    background: "#eeeeee",
  },
}));

const Ticket = ({ ticketId, byTicketManagement = false }) => {
  const history = useHistory();
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [drawerTransferModalOpen, setDrawerTransferModalOpenOpen] =
    useState(false);
  const [drawerConcludeTicketOpen, setDrawerConcludeTicketOpen] =
    useState(false);
  const [drawerFlashMessengerOpen, setDrawerFlashMessengerOpen] =
    useState(false);
  const [scheduleMessageOpen, setScheduleMessageOpen] = useState(false);
  const [drawerCreateTicketModalOpen, setDrawerCreateTicketModalOpen] =
    useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});
  const [forContactsModalOpen, setForContactsModalOpen] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const urlTicketUUID = GetUrlTicketPath();
  const [tags, setTags] = useState([]);
  const [groupInformationModal, setGroupInformationModal] = useState(false);

  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const profileOpen = Boolean(profileAnchorEl);
  const [searchWithinTheConversationOpen, setSearchWithinTheConversationOpen] =
    useState(null);

  const { adminId } = user;

  // modal de informações de contato
  const handleContactInfoOpen = () => {
    setContactModalOpen(true);
  };

  const handleContactInfoClose = () => {
    setContactModalOpen(false);
  };

  // Modal de agendamento de mensagens
  const handleScheduleMessageOpen = () => {
    setScheduleMessageOpen(true);
  };

  const handleScheduleMessageClosed = () => {
    setScheduleMessageOpen(false);
  };

  // Modal Informacoes de Contato

  // Modal Transferencia
  const handleDrawerTransferTicketOpen = () => {
    setDrawerTransferModalOpenOpen(true);
  };
  const handleTransferModalClose = () => {
    setDrawerTransferModalOpenOpen(false);
  };

  const handleDrawerConcludeTicketClose = () => {
    setDrawerConcludeTicketOpen(false);
  };

  // Modal de informações de grupo
  const handleGroupInformation = (status) => {
    setGroupInformationModal(status == true ? true : false);
  };

  // Modal Mensagens Rapidas
  const handleDrawerFlashMessengerOpen = () => {
    setDrawerFlashMessengerOpen(true);
  };
  const handleDrawerFlashMessengerClose = () => {
    setDrawerFlashMessengerOpen(false);
  };

  // Modal Criar Ticket **Desabilitado**
  const handleDrawerCreateTicketModalClose = () => {
    setDrawerCreateTicketModalOpen(false);
  };

  const handleOpenForContactsModal = () => {
    setForContactsModalOpen(true);
  };

  const handleCloseForContactsModal = () => {
    setForContactsModalOpen(false);
  };

  const handleDrawerConcludeTicketOpen = () => {
    setDrawerConcludeTicketOpen(true);
  };

  const handleAddForContactsModal = (tagsIdReturn) => {
    if (!tagsIdReturn || tagsIdReturn.length < 1)
      setContact({ ...contact, tagsId: null });
  };

  useEffect(() => {
    if (!ticketId || ticketId == "undefined") return;
    setLoading(true);
    let isMounted = true;
    const abortController = new AbortController();

    const delayDebounceFn = setTimeout(() => {
      const fetchTicket = async () => {
        try {
          const { data } = await api.get("/tickets/u/" + ticketId, {
            signal: abortController.signal,
          });
          if (!isMounted) return;
          const ct = data.Contact;
          setContact(ct);
          setTicket(data);
        } catch (err) {
          if (!isMounted || err.name == "AbortError") return;
          console.error({ err });
          toastError(err);
        } finally {
          setLoading(false);
        }
      };
      fetchTicket();
    }, 500);

    return () => {
      isMounted = false;
      abortController.abort();
      clearTimeout(delayDebounceFn);
    };
  }, [ticketId]);

  useEffect(() => {
    const joinChatBox = () => {
      if (ticket?.id) socket.emit("joinChatBox", `${ticket.id}`);
    };
    if (socket.connected) joinChatBox();
    socket.on("connect", joinChatBox);

    const ticketEventName = `ticket-${adminId}`;
    const ticketEventFunction = async (data) => {
      if (data.action === "update") {
        if (data.message?.ticket?.uuid === urlTicketUUID) {
          if (data.message?.ticket) setTicket(data.message.ticket);
          else if (data.ticket) setTicket(data.ticket);
        }

        // verificar se o ticket está aberto ou aguardando e possuí contato
        if (ticketId && ticketId != "undefined") {
          const { ticket } = data;

          if (ticket?.uuid == ticketId && ticket.Contact) {
            setContact(ticket.Contact);
            setTicket(ticket);
          }
        }
      }

      if (data.action === "delete" && ticket.id === data.ticketId) {
        if (data.message?.ticket?.uuid === urlTicketUUID) {
          history.push("/tickets");
        }
      }
    };

    const contactListener = `contact-${adminId}`;
    const contactEvent = async (data) => {
      if (data.action === "update") {
        setContact((prevState) => {
          if (prevState.id === data.contact?.id) {
            return { ...prevState, ...data.contact };
          }
          return prevState;
        });
        setTicket((prevState) => {
          if (!prevState) return prevState;
          const isCurrentTicketContact = prevState?.Contact?.id === data.contact?.id;
          const participants = Array.isArray(prevState?.GroupInformations?.participants)
            ? prevState.GroupInformations.participants.map((participant) => {
                const participantNumber = String(participant?.number || "").split("@")[0].split(":")[0];
                const participantLid = String(
                  participant?.lid || participant?.LID || participant?.id || participant?.JID || ""
                );
                const contactNumber = String(data.contact?.number || "").split("@")[0].split(":")[0];
                const contactLid = String(data.contact?.lid || "");
                const sameParticipant =
                  (participantNumber && participantNumber === contactNumber) ||
                  (contactLid && participantLid === contactLid);
                if (!sameParticipant) return participant;
                return {
                  ...participant,
                  name: data.contact?.name || participant?.name,
                  profilePictureUrl: data.contact?.profilePicUrl || participant?.profilePictureUrl,
                };
              })
            : prevState?.GroupInformations?.participants;
          return {
            ...prevState,
            Contact: isCurrentTicketContact
              ? { ...prevState.Contact, ...data.contact }
              : prevState.Contact,
            GroupInformations: {
              ...prevState.GroupInformations,
              contactPictureUrl: isCurrentTicketContact
                ? data.contact?.profilePicUrl || prevState?.GroupInformations?.contactPictureUrl
                : prevState?.GroupInformations?.contactPictureUrl,
              profilePictureUrl: isCurrentTicketContact
                ? data.contact?.profilePicUrl || prevState?.GroupInformations?.profilePictureUrl
                : prevState?.GroupInformations?.profilePictureUrl,
              participants,
            },
          };
        });
      }
    };

    const whatsappEventName = `whatsapp-${adminId}`;
    const whatsappEvent = async (data) => {
      if (data.action !== "update" || !data.whatsapp?.id) return;
      setTicket((prevState) => {
        if (prevState?.whatsapp?.id !== data.whatsapp.id) return prevState;
        return {
          ...prevState,
          whatsapp: {
            ...prevState.whatsapp,
            ...data.whatsapp,
          },
        };
      });
    };

    socket.on(contactListener, contactEvent);
    socket.on(ticketEventName, ticketEventFunction);
    socket.on(whatsappEventName, whatsappEvent);

    return () => {
      socket.off("connect", joinChatBox);
      socket.off(contactListener, contactEvent);
      socket.off(ticketEventName, ticketEventFunction);
      socket.off(whatsappEventName, whatsappEvent);
    };
  }, [ticketId, ticket]);

  useEffect(() => {
    if (!ticketId || ticketId == "undefined") return;
    let isMounted = true;
    const abortController = new AbortController();

    async function getTags() {
      try {
        const { data } = await api.get("/tags", {
          signal: abortController.signal,
        });
        if (!isMounted) return;
        if (!data || !data.tags) data.tags = [];
        if (data.tags)
          data.tags.unshift({
            id: 0,
            adminId: user.adminId,
            color: "#000000",
            name: "sem etiqueta",
            updatedBy: user.id,
            status: 1,
          });
        setTags(data.tags);
      } catch (error) {
        if (!isMounted || error.name == "AbortError") return;
        console.error(error);
      }
    }

    getTags();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, []);

  const QuickMessageIcon = ({ ...props }) => {
    return (
      <Box display="flex" flexDirection="column" alignItems="center">
        <ChatBubbleIcon {...props} />
        <FlashOnIcon
          className={classNames({
            [classes.flashOnIcon]: true,
            [classes.flashOnIconDisabled]:
              props?.disabled == true ? true : false,
          })}
        />
      </Box>
    );
  };

  const transferToAwait = async () => {
    setLoading(true);

    let data = {};
    data.isCampaign = false;
    data.status = "pending";

    try {
      await api.put(`/tickets/${ticket.id}`, data);
      toast.success("Movido com sucesso!");
    } catch (err) {
      console.err(err);
    }
    setLoading(false);
    if (byTicketManagement != true) history.push(`/tickets`);
  };

  const setUnareadConversation = async () => {
    try {
      setLoading(true);

      await api.post(`/tickets/setUnread`, {
        ticketsIds: [ticket.id],
      });

      toast.success("Atualizado com sucesso!");
      history.push("/tickets");
      //handleBack();
    } catch (err) {
      console.error(err);
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  // Função para navegar de volta
  // const handleBack = () => {
  //   if (byTicketManagement === true) {
  //     history.push("/ticketManagement");
  //   } else {
  //     history.push("/tickets");
  //   }
  // };

  const RenderMessagesList = useMemo(() => {
    if (!ticket || !ticket?.id) return;

    const canSendMessageForGroup =
      ticket?.GroupInformations &&
      ticket?.GroupInformations?.canSendMessage == true;

    return (
      <>
        <MessagesList
          ticket={ticket}
          ticketId={ticket?.id}
          isGroup={
            ticket?.isGroup == true || ticket?.Contact?.isGroup == true
              ? true
              : false
          }
          byTicketManagement={byTicketManagement == true ? true : false}
          ctcId={ticket?.Contact?.id}
          searchOpen={searchWithinTheConversationOpen}
        />
        {
          <MessageInput
            ticketId={ticket.id}
            uuid={ticket.uuid}
            ticketStatus={ticket.status}
            contactId={ticket?.Contact?.id || ticket.contactId}
            whatsapp={ticket.whatsapp}
            ticketQueue={ticket.queueId}
            byTicketManagement={byTicketManagement}
            canSendMessageForGroup={
              ((ticket?.isGroup == true || ticket?.Contact?.isGroup == true) &&
                canSendMessageForGroup == true) ||
              (ticket?.isGroup != true && ticket?.Contact?.isGroup != true)
                ? true
                : false
            }
          />
        }
      </>
    );
  }, [ticket, searchWithinTheConversationOpen]);

  function retornaDados(ticket) {
    if (!ticket.Contact) return;

    const { whatsapp, Queue } = ticket;

    const getFilaText = () => {
      if (whatsapp?.moduleId == 2) {
        if (!Queue)
          return `<b style="display: block">${whatsapp.name}</b> Sem fila`;
        return `<b style="display: block">${whatsapp.name}</b> ${Queue.name}`;
      } else {
        if (ticket.Contact) {
          if (ticket) {
            if (ticket.whatsapp) {
              return `<b style="display: block">${ticket?.whatsapp?.name}</b> ${ticket.whatsapp.numberConnection}`;
            } else {
              return `<b style="display: block">Sem Conexão</b> ${ticket.whatsapp.numberConnection || ticket.numberConnection}`;
            }
          } else {
            return `<b style="display: block">Sem Conexão</b> ${ticket.whatsapp.numberConnection || ticket.numberConnection}`;
          }
        }
      }
    };

    const montarFila = getFilaText();
    const pegarImg =
      whatsapp?.picConnection || profileNoPic || "/media/avatars/blank.png";

    const elementPicConnection = document.getElementById("picConnection");
    if (elementPicConnection) elementPicConnection.src = pegarImg;

    const elementDefinirFila = document.getElementById("definirFila");
    if (elementDefinirFila) elementDefinirFila.innerHTML = montarFila;
  }

  const menuOptions = [
    {
      title: i18n.t("ticketOptionsMenu.searchWithinTheConversation"),
      onClick: () => setSearchWithinTheConversationOpen(new Date().getTime()),
      icon: <SearchOutlinedIcon />,
      disabled: loading,
      extraCondition: true,
      status: ["open", "pending", "closed"],
    },
    {
      title: i18n.t("messagesList.header.buttons.groupInfo"),
      onClick: () => handleGroupInformation(true),
      icon: <GroupIcon />,
      disabled:
        !ticket?.whatsapp?.status ||
        String(ticket.whatsapp.status).toLowerCase() != "connected" ||
        loading ||
        (user?.profile != "admin" && user?.managementGroup != true) ||
        ((ticket?.isGroup == true || ticket?.Contact?.isGroup == true) &&
          !ticket?.GroupInformations),
      extraCondition: ticket?.isGroup == true ? true : false,
      status: ["open", "pending", "closed"],
    },
    {
      title: i18n.t("messagesList.header.buttons.autoMessage"),
      onClick: handleDrawerFlashMessengerOpen,
      icon: <QuickMessageIcon />,
      disabled:
        !ticket?.whatsapp?.status ||
        String(ticket.whatsapp.status).toLowerCase() != "connected" ||
        loading ||
        ((ticket?.isGroup == true || ticket?.Contact?.isGroup == true) &&
          !(
            ticket?.GroupInformations &&
            ticket?.GroupInformations?.canSendMessage == true
          )),
      extraCondition: true,
      status: ["open", "pending"],
    },
    {
      title: i18n.t("messagesList.header.buttons.contactInfo"),
      onClick: handleContactInfoOpen,
      icon: <PermContactCalendarOutlinedIcon />,
      disabled:
        !ticket?.whatsapp?.status ||
        String(ticket.whatsapp.status).toLowerCase() != "connected" ||
        loading ||
        ((ticket?.isGroup == true || ticket?.Contact?.isGroup == true) &&
          !ticket?.GroupInformations),
      status: ["open", "pending"],
      extraCondition: CheckComponentAccess(user, "customerRelationship"),
    },
    {
      title: i18n.t("ticketOptionsMenu.linkTags"),
      onClick: handleOpenForContactsModal,
      icon: <LabelOutlinedIcon />,
      disabled:
        !ticket?.whatsapp?.status ||
        String(ticket.whatsapp.status).toLowerCase() != "connected" ||
        loading ||
        ((ticket?.isGroup == true || ticket?.Contact?.isGroup == true) &&
          !ticket?.GroupInformations),
      status: ["open", "pending", "closed"],
      extraCondition: true,
    },
    {
      title: i18n.t("ticketOptionsMenu.scheduleMessage"),
      onClick: handleScheduleMessageOpen,
      icon: <AlarmOutlinedIcon />,
      disabled:
        !ticket?.whatsapp?.status ||
        String(ticket.whatsapp.status).toLowerCase() != "connected" ||
        (ticket.whatsapp?.moduleId != 1 && ticket.whatsapp?.moduleId != 4) ||
        loading ||
        ((ticket?.isGroup == true || ticket?.Contact?.isGroup == true) &&
          !(
            ticket?.GroupInformations &&
            ticket?.GroupInformations?.canSendMessage == true
          )),
      status: ["open", "pending", "closed"],
      extraCondition: true,
    },
    {
      title: i18n.t("ticketOptionsMenu.markAsUnread"),
      onClick: setUnareadConversation,
      icon: <NotificationsIcon />,
      disabled: loading,
      extraCondition: true,
      status: ["open", "pending"],
    },
    {
      title: i18n.t("ticketOptionsMenu.transferToAwait"),
      onClick: transferToAwait,
      icon: <PauseCircleOutlineOutlinedIcon />,
      disabled:
        !ticket?.whatsapp?.status ||
        String(ticket.whatsapp.status).toLowerCase() != "connected" ||
        loading ||
        ((ticket?.isGroup == true || ticket?.Contact?.isGroup == true) &&
          !ticket?.GroupInformations),
      status: ["open"],
      extraCondition: ticket.status == "open",
    },
    {
      title: i18n.t("ticketOptionsMenu.transfer"),
      onClick: handleDrawerTransferTicketOpen,
      icon: <SwapHorizIcon />,
      disabled:
        !ticket?.whatsapp?.status ||
        String(ticket.whatsapp.status).toLowerCase() != "connected" ||
        loading ||
        ((ticket?.isGroup == true || ticket?.Contact?.isGroup == true) &&
          !ticket?.GroupInformations),
      status: ["open", "pending"],
      extraCondition: true,
    },
    {
      title: i18n.t("messagesList.header.buttons.conclude"),
      onClick: handleDrawerConcludeTicketOpen,
      icon: <HowToRegOutlinedIcon />,
      disabled: !ticket?.whatsapp?.status || loading,
      status: ["open", "pending"],
      extraCondition: true,
    },
  ];

  const handleProfileClose = () => {
    setProfileAnchorEl(null);
  };

  const handleProfileClick = (event) => {
    setProfileAnchorEl(event.currentTarget);
  };

  return (
    <div className={classes.root} id="drawer-container">
      <Paper
        variant="outlined"
        elevation={0}
        className={clsx(classes.mainWrapper)}
      >
        <TicketHeader
          loading={loading}
          byTicketManagement={byTicketManagement == true ? true : false}
        >
          <Box className={classes.header}>
            {retornaDados(ticket)}
            <TicketInfo
              contact={contact}
              ticket={ticket}
              onClick={handleContactInfoOpen}
            />
            <Box className={classes.buttonBox}>
              <Box component="div" className={classes.buttonDesktop}>
                {menuOptions
                  .filter(
                    (mOption) =>
                      mOption.extraCondition == true &&
                      mOption.status.includes(ticket.status)
                  )
                  .map((mOption) => {
                    return (
                      <Tooltip title={mOption.title}>
                        <IconButton
                          className={classes.icon}
                          disabled={mOption.disabled}
                          onClick={mOption.onClick}
                        >
                          {mOption.icon}
                        </IconButton>
                      </Tooltip>
                    );
                  })}
              </Box>
              <Box component="div" className={classes.buttonMobile}>
                <IconButton onClick={handleProfileClick}>
                  <KeyboardArrowDownOutlinedIcon />
                </IconButton>
                <Popover
                  id={ticket?.id}
                  open={profileOpen}
                  anchorEl={profileAnchorEl}
                  onClose={handleProfileClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <List style={{ textTransform: "capitalize" }}>
                    {menuOptions
                      .filter(
                        (mOption) =>
                          mOption.extraCondition == true &&
                          mOption.status.includes(ticket.status)
                      )
                      .map((mOption) => {
                        return (
                          <ListItem
                            button
                            onClick={() => {
                              handleProfileClose();
                              mOption.onClick();
                            }}
                          >
                            <ListItemText primary={mOption.title} />
                          </ListItem>
                        );
                      })}
                  </List>
                </Popover>
              </Box>
            </Box>
          </Box>
        </TicketHeader>
        <ReplyMessageProvider>{RenderMessagesList}</ReplyMessageProvider>
      </Paper>
      <ScheduleMessageListModal
        ticketId={ticket?.id}
        contactId={contact?.id}
        connectionId={ticket?.whatsapp?.id}
        open={scheduleMessageOpen}
        onClose={handleScheduleMessageClosed}
        onConfirm={(e) => {}}
      />
      <ContactTransferModal
        open={drawerTransferModalOpen}
        onClose={handleTransferModalClose}
        contact={contact}
        ticket={ticket}
        user={user}
        byTicketManagement={byTicketManagement}
      />
      <ContactConcludeTicket
        open={drawerConcludeTicketOpen}
        handleDrawerClose={handleDrawerConcludeTicketClose}
        contact={contact}
        ticketid={ticketId}
        ticket={ticket}
        loading={loading}
        byTicketManagement={byTicketManagement}
        canSendMessageForGroup={
          ticket?.GroupInformations &&
          ticket?.GroupInformations?.canSendMessage == true
        }
      />
      <ContactFlashMessenger
        open={drawerFlashMessengerOpen}
        handleDrawerClose={handleDrawerFlashMessengerClose}
        contact={contact}
        ticketid={ticket.id}
        ticket={ticket}
        loading={loading}
      />
      <ContactCreateTicketModal
        open={drawerCreateTicketModalOpen}
        handleDrawerClose={handleDrawerCreateTicketModalClose}
        contact={contact}
        ticketid={ticketId}
        initialContact={{}}
        loading={loading}
      />
      <ForContactsModal
        open={forContactsModalOpen}
        onClose={handleCloseForContactsModal}
        onSave={handleAddForContactsModal}
        aria-labelledby="form-dialog-title"
        tagsId={contact?.tagsId}
        contactId={contact.id}
      />
      <ContactModal
        open={contactModalOpen}
        onClose={handleContactInfoClose}
        aria-labelledby="form-dialog-title"
        contactId={contact.id}
        tags={tags.filter((tag) => tag.id >= 1 && tag.status === 1)}
      />
      <GroupInformationModal
        open={groupInformationModal == true ? true : false}
        onClose={() => {
          handleGroupInformation(false);
        }}
        connectionId={ticket?.whatsappId || undefined}
        contactId={ticket?.contactId || undefined}
        numberConnection={ticket?.whatsapp?.numberConnection || undefined}
      />
    </div>
  );
};

export default Ticket;
